export function drawOutherLines(
  ctx,
  edgeOverlay,
  offsetHeight,
  offsetWidth,
  img,
  allRetriesFailed
) {
  img.onload = function () {
    ctx.drawImage(
      img,
      edgeOverlay,
      edgeOverlay,
      offsetWidth - edgeOverlay * 2,
      offsetHeight - edgeOverlay * 2
    );
    if (!allRetriesFailed) {
      ctx.beginPath();
      ctx.moveTo(edgeOverlay - 0.4 * edgeOverlay, edgeOverlay * 2);
      ctx.lineTo(
        edgeOverlay - 0.4 * edgeOverlay,
        edgeOverlay - 0.4 * edgeOverlay
      );
      ctx.lineTo(edgeOverlay * 2, edgeOverlay - 0.4 * edgeOverlay);
      ctx.moveTo(
        edgeOverlay - 0.4 * edgeOverlay,
        offsetHeight - 2 * edgeOverlay
      );
      ctx.lineTo(
        edgeOverlay - 0.4 * edgeOverlay,
        offsetHeight - 0.4 * edgeOverlay
      );
      ctx.lineTo(2 * edgeOverlay, offsetHeight - 0.4 * edgeOverlay);
      ctx.moveTo(
        offsetWidth - 2 * edgeOverlay,
        edgeOverlay - 0.4 * edgeOverlay
      );
      ctx.lineTo(
        offsetWidth - 0.4 * edgeOverlay,
        edgeOverlay - 0.4 * edgeOverlay
      );
      ctx.lineTo(offsetWidth - 0.4 * edgeOverlay, edgeOverlay * 2);
      ctx.moveTo(
        offsetWidth - 2 * edgeOverlay,
        offsetHeight - 0.4 * edgeOverlay
      );
      ctx.lineTo(
        offsetWidth - 0.4 * edgeOverlay,
        offsetHeight - 0.4 * edgeOverlay
      );
      ctx.lineTo(
        offsetWidth - 0.4 * edgeOverlay,
        offsetHeight - 2 * edgeOverlay
      );
      ctx.lineWidth = 4;
      ctx.strokeStyle = "blue";
      ctx.stroke();
    }
  };
}
